import { OrderModels, ResData } from '../types';
import { API } from './axios';

export async function getOrderById(data: { id: number }): Promise<ResData<OrderModels.Order>> {
  const response = await API.post<ResData>('/seller/order/show', data);

  return response.data;
}
export async function updateOrderStatus(data: {
  id: number;
  order_items: { id: number; status: number }[];
}): Promise<ResData> {
  const response = await API.post<ResData>('/seller/order/update', data);

  return response.data;
}
